{
  "version": 1,
  "asset_id": "c450c685-4ac4-42f7-80f8-d47d73daefa8",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/c450c685-4ac4-42f7-80f8-d47d73daefa8/loc-plano-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/c450c685-4ac4-42f7-80f8-d47d73daefa8/loc-plano-640.avif",
  "original_filename": "loc-plano-640.avif",
  "size": 18630,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:31Z"
}
